<template>
  <div class="move mv1 is-fullwidth">
    <h2>Change "{{ question.title }}" to a:</h2>
    <div class="columns mt1">
      <div class="column">
        <ul>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('singletext', 0) }
              ]"
              @click="changeType('singletext', 0)"
            >
              Single Text
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('multitext', 0) }
              ]"
              @click="changeType('multitext', 0)"
            >
              Multi Text
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('date', 0) }
              ]"
              @click="changeType('date', 0)"
            >
              Date
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('multichoice', 0) }
              ]"
              @click="changeType('multichoice', 0)"
            >
              Multi Choice
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('checkbox', 0) }
              ]"
              @click="changeType('checkbox', 0)"
            >
              Checkboxes
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('file', 10) }
              ]"
              @click="changeType('file', 10)"
            >
              File
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('stripe', 11) }
              ]"
              @click="changeType('stripe', 11)"
            >
              Stripe
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('instruction', 13) }
              ]"
              @click="changeType('instruction', 13)"
            >
              Instruction
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('video', 14) }
              ]"
              @click="changeType('video', 14)"
            >
              Video
            </button>
          </li>
        </ul>
      </div>
      <div class="column">
        <ul>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('multitext', 1) }
              ]"
              @click="changeType('multitext', 1)"
            >
              Name
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('email', 2) }
              ]"
              @click="changeType('email', 2)"
            >
              Email
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('zip', 5) }
              ]"
              @click="changeType('zip', 5)"
            >
              Zip Code
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('phone', 4) }
              ]"
              @click="changeType('phone', 4)"
            >
              Phone
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('multichoice', 12) }
              ]"
              @click="changeType('multichoice', 12)"
            >
              Referral Reason
            </button>
          </li>
          <li>
            <button
              :class="[
                'button',
                'is-link',
                { 'is-primary is-outlined': current('casegrid', 0) }
              ]"
              @click="changeType('casegrid', 0)"
            >
              Case Grid
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="field is-grouped mt2 has-text-right">
      <div class="control">
        <button type="button" class="button is-link" @click="$emit('hide')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "question-type",

  props: ["question"],

  methods: {
    hide() {
      this.$emit("hide");
    },

    current(kind, dataType) {
      const dataTypes = [
        "dt_custom",
        "dt_name",
        "dt_email",
        "dt_birthday",
        "dt_phone",
        "dt_zip",
        "dt_location",
        "dt_schedule",
        "dt_insurance",
        "dt_phq9",
        "dt_file",
        "dt_stripe",
        "dt_referral_reason",
        "dt_instruction",
        "" + "dt_video"
      ];
      return (
        kind === this.$props.question.kind &&
        dataTypes[dataType] === this.$props.question.dataType
      );
    },

    changeType(type, dataType) {
      const newType = {
        id: this.question.id,
        kind: type,
        dataType
      };

      switch (type) {
        case "multitext":
          newType.fields = [
            { choice: this.getPreviousChoice(1) },
            { choice: this.getPreviousChoice(2) }
          ];
          break;
        case "multichoice":
        case "casegrid":
        case "checkbox":
          newType.fields = [
            { choice: this.getPreviousChoice(1), weight: 1 },
            { choice: this.getPreviousChoice(2), weight: 1 }
          ];
          break;
        case "instruction":
          newType.fields = [{ choice: this.getPreviousChoice(1) }];
          break;
        default:
          newType.fields = {};
          break;
      }

      InterviewsService.updateQuestion(newType).then(() => {
        this.hide();
      });
    },

    getPreviousChoice(index) {
      let choice = index.toString();
      if (_.has(this.question.fields[index - 1], "choice")) {
        choice = this.question.fields[index - 1].choice;
      }

      return choice;
    }
  }
};
</script>

<style lang="scss" scoped></style>
